module.exports = __webpack_public_path__ + "img/group-1.d8685cc8.png";